<template>
    <v-app>
        <v-container>
            <v-row>
                <v-col md="10" offset-lg="1">
                    <v-container style="height: 400px;" v-if="loading">
                        <v-row
                            class="fill-height"
                            align-content="center"
                            justify="center"
                        >
                            <v-col
                                class="text-subtitle-1 text-center"
                                cols="12"
                            >
                                Loading, please wait...
                            </v-col>
                            <v-col cols="6">
                                <v-progress-linear
                                    color="deep-purple accent-4"
                                    indeterminate
                                    rounded
                                    height="6"
                                ></v-progress-linear>
                            </v-col>
                        </v-row>
                    </v-container>
                    <!-- <kiosk></kiosk> -->
                    <component :is="mainComponent" v-else/>
                </v-col>
            </v-row>
            <modal-container></modal-container>
        </v-container>

    </v-app>
</template>

<script>

import {mapActions}   from "vuex";
import EventManager   from "../plugins/EventManager";
import ModalContainer from "./modals/ModalContainer";
import moment from "moment";

export default {
    name      : "App",
    components:{ModalContainer},
    methods   : {
        ...mapActions(['do_load_all_resources'])
    },
    computed  : {
        loading() {
            return this.$store.state.config.loading;
        },
        mainComponent() {
            return this.$store.state.component;
        }
    },
    async created() {
        const self = this;
        window.EM = new EventManager(() => {
            return self.$store
        });
        if(window.location.href.includes('seasonal')){
            const newEnvironment = [...self.$store.state.meta.environment,'seasonal'];
            self.$store.commit('set_kiosk_environment', newEnvironment);
        }
        window.EM.watchStore(function (state) {
            const {date_pickup, date_return, is_delivery, is_prepay, pickup_day, first_name} = state.model.reservation;
            return JSON.stringify({date_pickup, date_return, is_delivery, is_prepay, pickup_day, first_name});
        }, async function (store) {
            if (store.state.model.reservation.is_seasonal) {
                let currentMoment = moment(new Date());
                let seasonStartMoment = moment(new Date(store.state.resources.config.season_start));

                let date_pickup = moment(currentMoment).isAfter(seasonStartMoment)
                    ? currentMoment.format("MM/DD/YYYY")
                    : seasonStartMoment.format("MM/DD/YYYY");

                store.commit('set_model_value', { path: 'model.reservation.date_pickup', value: date_pickup });
                store.commit('set_model_value', { path: 'model.reservation.date_return', value: store.state.resources.config.season_return });
            }

            if(store.state.model.reservation.is_prepay){
                store.commit('set_model_value',{path:'model.reservation.date_pickup',value: moment(new Date()).format("MM/DD/YYYY")})
                store.commit('set_model_value',{path:'model.reservation.date_return',value: store.state.resources.config.season_return})
            }
            if(store.state.model.reservation.group_link_id != 0){
                store.commit('set_model_value', { path: 'model.reservation.date_pickup', value: store.state.resources.config.group_date_pickup });
                store.commit('set_model_value', { path: 'model.reservation.date_return', value: store.state.resources.config.group_date_return });
                await store.dispatch('load__group_packages');
            }else{
                await store.dispatch('load__packages');
            }
            if(store.state.model.reservation.group_link_id == 0 && !store.state.model.reservation.is_prepay){
                await store.dispatch('load__package_addons');
            }
            if(window.location.href.includes('delivery')){
                await store.dispatch('load__pickup_hours');
            }
            if(window.location.href.includes('prepay')){
                await store.dispatch('load__prepay_packages');
            }
        });
       /* window.EM.watchStore(function (state) {
            return state.model.reservation.is_international_customer;
        }, function (store, newVal) {
            const clearFields = newVal ? ['postal_code', 'country', 'province'] : ['zip', 'state'];
            clearFields.forEach(f => store.commit('set_model_value', {path: 'model.reservation.' + f, value: null}));
            store.dispatch('set_model_value', {path: 'model.reservation.zip', value: newVal ? '11111' : ''});

        });*/
        await this.do_load_all_resources();
        self.$store.commit('set_loading', false);
    },
    mounted(){

    }
}
</script>

<style>
.big-menu {
    max-height: 400px !important;
}
</style>
